import "../../index59.css";
import { jsxs as v, jsx as o } from "react/jsx-runtime";
import u, { useRef as F, useEffect as P } from "react";
import { i as w, a as U } from "../../type-BFTbooL7.js";
import { _ as f } from "../../cs-piwRuCFZ.js";
import { r as q } from "../../string-COe5rUcp.js";
import { l as G } from "../../transform-VOqkQszh.js";
import { s as b } from "../../statistics-IyDYgeE6.js";
import J from "../DefaultMessage/index.js";
import { WIDTH_DEFAULT_TABLE_COLUMN as K } from "../../utils/constants.js";
import Q from "./TableBodyContent/index.js";
import V from "./TableHeader/index.js";
import X from "./TableRow/index.js";
const Y = "_table_nilhy_1", Z = "_table-overflow-wrapper_nilhy_8", ee = "_table-element_nilhy_13", te = "_header-row_nilhy_23", ae = "_header-element_nilhy_24", ne = "_header-component_nilhy_29", d = {
  table: Y,
  tableOverflowWrapper: Z,
  tableElement: ee,
  headerRow: te,
  headerElement: ae,
  headerComponent: ne
};
function re(_, c) {
  return c ?? _.columnWidth ?? K;
}
function be(_) {
  const {
    data: c,
    keySelector: x,
    columns: l,
    caption: W,
    className: T,
    captionClassName: $,
    headerRowClassName: M,
    headerCellClassName: y,
    rowClassName: S,
    cellClassName: z,
    rowModifier: B,
    fixedColumnWidth: C,
    resizableColumn: g,
    headersHidden: D,
    pending: O,
    filtered: k,
    errored: j = !1
  } = _, N = F(null), [h] = u.useState(() => q()), [m, R] = u.useState({});
  P(() => {
    R((n) => {
      if (w(N.current))
        return n;
      const t = N.current.getBoundingClientRect(), { width: a } = t;
      let r = l.map(
        (e) => ({
          id: e.id,
          stretch: !!e.columnStretch,
          width: re(e, n[e.id])
        })
      );
      const s = b(
        r.filter((e) => e.stretch).map((e) => e.width)
      ), p = b(
        r.filter((e) => !e.stretch).map((e) => e.width)
      ), i = (a - p) / s;
      return i > 1 && (r = r.map((e) => ({
        ...e,
        width: e.stretch ? e.width * i : e.width
      }))), G(
        r,
        (e) => e.id,
        (e) => e.width
      );
    });
  }, [l]);
  const H = u.useCallback(
    (n, t) => {
      const a = document.getElementById(`${h}-${t}`), r = Math.max(n, 80);
      if (w(a) || (a.style.width = `${r}px`, !C))
        return;
      const s = document.getElementById(h);
      if (w(s))
        return;
      const p = b(l.map((i) => i.id === t ? r : m[i.id]));
      s.style.width = `${p}px`;
    },
    [h, m, l, C]
  ), I = u.useCallback(
    (n, t) => {
      U(t) && R((a) => ({
        ...a,
        [t]: Math.max(n, 80)
      }));
    },
    [R]
  ), L = u.useMemo(() => b(l.map((n) => m[n.id])), [m, l]), E = w(c) || c.length === 0 || Object.keys(m).length === 0;
  return /* @__PURE__ */ v(
    "div",
    {
      ref: N,
      className: f(d.table, T),
      children: [
        !E && /* @__PURE__ */ o("div", { className: d.tableOverflowWrapper, children: /* @__PURE__ */ v(
          "table",
          {
            className: d.tableElement,
            style: C ? { width: `${L}px` } : void 0,
            id: h,
            children: [
              W && /* @__PURE__ */ o("caption", { className: $, children: W }),
              /* @__PURE__ */ o("colgroup", { children: l.map((n) => {
                const {
                  id: t,
                  columnClassName: a
                } = n, r = m[t], s = C ? { width: `${r}px` } : void 0;
                return /* @__PURE__ */ o(
                  "col",
                  {
                    id: `${h}-${t}`,
                    style: s,
                    className: f(d.column, a)
                  },
                  t
                );
              }) }),
              !D && /* @__PURE__ */ o("thead", { children: /* @__PURE__ */ o(
                X,
                {
                  className: f(d.headerRow, M),
                  children: l.map((n, t) => {
                    const {
                      id: a,
                      title: r,
                      headerCellRenderer: s,
                      headerCellRendererClassName: p,
                      headerCellRendererParams: i,
                      headerContainerClassName: e
                    } = n, A = /* @__PURE__ */ o(
                      s,
                      {
                        ...i,
                        name: a,
                        title: r,
                        index: t,
                        className: f(
                          p,
                          d.headerComponent
                        )
                      }
                    );
                    return /* @__PURE__ */ o(
                      V,
                      {
                        scope: "col",
                        name: a,
                        onResize: g ? H : void 0,
                        onResizeComplete: g ? I : void 0,
                        className: f(
                          d.headerElement,
                          typeof y == "function" ? y(a) : y,
                          e
                        ),
                        children: A
                      },
                      a
                    );
                  })
                }
              ) }),
              /* @__PURE__ */ o("tbody", { children: /* @__PURE__ */ o(
                Q,
                {
                  data: c,
                  keySelector: x,
                  columns: l,
                  rowClassName: S,
                  cellClassName: z,
                  rowModifier: B
                }
              ) })
            ]
          }
        ) }),
        /* @__PURE__ */ o(
          J,
          {
            filtered: k,
            empty: E,
            errored: j,
            pending: O,
            overlayPending: !0
          }
        )
      ]
    }
  );
}
export {
  be as default
};
